import reactBootstrap from "./react/reactBoostrapper";
import { piwikTracker } from "./components/piwikTracker";
import { svgInject } from "./components/svgInject";
import { lazyLoad } from "./components/lazyLoad";
import { accordion } from "./components/accordion";
import { navbarBurger } from "./components/navbarBurger";
import { navbarNavigation } from "./components/navbarNavigation";
import { customAudioPlayerInit } from "./components/customAudioPlayerInit";
import { tabSelection } from "./components/tabSelection";
import { fullsizeVideo } from "./components/fullsizeVideo";
import { copyButton } from "./components/copyButton";
import { newsletterAnchor } from "./components/newsletterAnchor";

// swiper
import swiperChampionshipRaces from "./components/swiper/swiperChampionshipRaces";
import swiperRaceDetails from "./components/swiper/swiperRaceDetails";
import swiperStaffCards from "./components/swiper/swiperStaffCards";
import swiperRacingSeason from "./components/swiper/swiperRacingSeason";
import swiperTimelineHistory from "./components/swiper/swiperTimelineHistory";
import swiperSingleCarousel from "./components/swiper/swiperSingleCarousel";
import swiperPalmares from "./components/swiper/swiperPalmares";
import swiperTimelineLiveries from "./components/swiper/swiperTimelineLiveries";
import swiperCarsLiveries from "./components/swiper/swiperCarsLiveries";
import swiperSquareCards from "./components/swiper/swiperSquareCards";
import swiperZoomCards from "./components/swiper/swiperZoomCards";

// GSAP
import { gsapNavbar } from "./components/gsap/gsapNavbar";
import { gsapAnimateOnScroll } from "./components/gsap/gsapAnimateOnScroll";
import { gsapMagneticButton } from "./components/gsap/gsapMagneticButton";
import { gsapParallax } from "./components/gsap/gsapParallax";
// import { gsapCustomCursor } from "./components/gsap/gsapCustomCursor";
import { gsapPinScroll } from "./components/gsap/gsapPinScroll";
import { gsapHorizontalTitle } from "./components/gsap/gsapHorizontalTitle";
import { gsapFullsizeTitle } from "./components/gsap/gsapFullsizeTitle";
import { gsapFullsizeVideo } from "./components/gsap/gsapFullsizeVideo";
import { gsapCardZoom } from "./components/gsap/gsapCardZoom";
import { gsapHorizontalItemScroll } from "./components/gsap/gsapHorizontalItemScroll";



let appBootstrap = ($) => {


    // Piwik events
    piwikTracker.init();


    // standard or jquery components
    svgInject.init();
    lazyLoad.init();
    accordion.init();
    navbarBurger.init();
    navbarNavigation.init();
    customAudioPlayerInit.init();
    tabSelection.init();
    fullsizeVideo.init();
    copyButton.init();
    newsletterAnchor.init();



    // swiper
    swiperRaceDetails.init();
    swiperChampionshipRaces.init();
    swiperStaffCards.init();
    swiperRacingSeason.init();
    swiperTimelineHistory.init();
    swiperSingleCarousel.init();
    swiperPalmares.init();
    swiperTimelineLiveries.init();
    swiperCarsLiveries.init();
    swiperSquareCards.init();
    swiperZoomCards.init();

    // GSAP
    gsapNavbar.init();
    gsapAnimateOnScroll.init();
    // gsapCustomCursor.init();
    gsapMagneticButton.init();
    gsapParallax.init();
    gsapPinScroll.init();
    gsapHorizontalTitle.init();
    gsapFullsizeTitle.init();
    gsapFullsizeVideo.init();
    gsapCardZoom.init();
    gsapHorizontalItemScroll.init();


    // react bootstrap
    reactBootstrap.init();
    window.reactBootstrap = reactBootstrap;
};

export const bootstrapper = {
    init: () => {
        appBootstrap(jQuery);
        return require("../../package.json").version; // return version nr from package.json
    },
};
